import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Nav() {
  const { pathname } = useLocation();

  const linkClass = (path) =>
    `transition-colors duration-300 ${
      pathname === path
        ? 'text-[#FFFFFF]'
        : 'text-[#666666] hover:text-[#AAAAAA]'
    }`;

  return (
    <nav className="animate-nav w-full flex items-center justify-between py-[1.5rem] border-b border-[#1A1A1A]">
      <Link
        to="/"
        className="font-semibold tracking-[0.15em] text-[1.1rem] uppercase text-[#FFFFFF] hover:text-[#A0A0A0] transition-colors duration-300"
      >
        AARON FIGUEROA
      </Link>
      <div className="flex gap-[1rem] md:gap-8 tracking-[0.1em] text-[0.85rem] uppercase">
        <Link to="/" className={linkClass('/')}>
          WORK
        </Link>
        <Link to="/about" className={linkClass('/about')}>
          ABOUT
        </Link>
      </div>
    </nav>
  );
}